import { ActionTree } from "vuex";
import { CustomerState } from "@/store/customer/type";
import { RootState } from "@/store/type";
import Api from "@/api/Api";
import { CustomerMutations } from "@/store/customer/mutations";
import { Customer } from "@/models/customer";
import { ShoppingCart } from "@/models/shopping";

export const actions: ActionTree<CustomerState, RootState> = {
  getMe: ({ commit }): Promise<Customer | null> | null => {
      return Api.account.getCustomer()
        .then((data: Customer) => {
          commit(CustomerMutations.SET_CUSTOMER, data);
          return data;
        })
        .catch((e) => {
          console.error(e);
          return null;
        });
  },

  setCart: ({ commit }, data: ShoppingCart) => {
    commit(CustomerMutations.SET_CART, data);
    return data;
  },

  setCustomer: ({ commit }, data: Customer) => {
    commit(CustomerMutations.SET_CUSTOMER, data);
    return data;
  },

  removeCustomerAddress({ commit }, addressName) {
    commit(CustomerMutations.REMOVE_ADDRESS, addressName);

  },

  addCustomerAddress({ commit }, { isNew, address }) {
    commit(CustomerMutations.ADD_ADDRESS, { isNew, address });

  },

  loginCustomer: ({ commit }, customer: Customer) => {
    commit(CustomerMutations.SET_CUSTOMER, customer);
  },

  logOutCustomer: ({ commit }) => {
    commit(CustomerMutations.SET_CUSTOMER, null);
  },
};